export default {
  common: {
    search: 'Suche',
    selected: 'Ausgewählt',
  },
  actions: {
    clear: 'Leeren',
  },
};
